import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import logo from "../assets/nelsonlogo/nelsoncenterlogo.png";

const LogoText = styled.h1`
  font-family: "Akaya Telivigala", cursive;
  font-size: ${(props) => props.theme.fontxxxl};
  color: ${(props) => props.theme.text};
  transition: all 0.2s ease;

  display: flex;
  align-items: center;
  // width: 2rem;
  marin-top: 4rem;
  height: 8rem;
  cursor: pointer;
  // border: 1px solid green;
  img {
    // margin-right: 0.5rem;
    max-width: 150px;
    margin-top: 20px;
    overflow: hidden;
  }

  &:hover {
    transform: scale(1.1);
  }

  @media (max-width: 64em) {
    font-size: ${(props) => props.theme.fontxxl};
  }
`;

const LogoFooter = () => {
  return (
    <LogoText>
      <Link to="/">
        <img src={logo} alt="CodeBucks" />
      </Link>
    </LogoText>
  );
};

export default LogoFooter;
